<div class="row ms-0 me-0">
    <span class="section col-12 p-3">
      <div class="row">
        <label for="asset">{{ 'pages.support.dashboard.fieldTitles.filterAsset' | translate }}</label>
      </div>
      <div class="row">

        <!-- BY VENDORS -->
        <div class="col-4">
          <div class="d-flex custom-select">
            <select class="form-select delete-opt" [(ngModel)]="assetFilter.vendor" [ngModelOptions]="{standalone: true}" (change)="applyFilter()">
            <option value="">{{ 'pages.support.log.filterByVendor' | translate }}</option>
            <option value="{{vv}}" *ngFor="let vv of vendors">{{vv}}</option>
          </select>
              <!-- remove selected vendor -->
              <button type="button" class="btn btn-icon delete" (click)="removeSelectedVendor()" [disabled]="!assetFilter.vendor">
                <fa-icon
                  [icon]="['fas', 'times']" class="p-1" placement="top" data-toggle="tooltip" data-placement="top"
                  title="{{ 'pages.support.log.logAssetDesc' | translate }}"></fa-icon>
              </button>
          </div>
        </div>
        
        <span class="input-group-text col-1">&nbsp;</span>

        <!-- BY SERIAL NUMBER OR NAME -->
        <div class="col-7">
          <input type="search" class="form-control" placeholder="Filter by serial number or name..."
            [(ngModel)]="assetFilter.search" [ngModelOptions]="{standalone: true}" title="{{ 'pages.assets.dashboard.assetSearchDesc' | translate }}"
            (keyup)="applyFilter()" (search)='applyFilter()'>
        </div>
      </div>
      <div class="row mt-2">

        <!-- asset filter-->
        <div class="col-12" ngbDropdown>

          <!-- button -->
          <button class="btn" type="button" id="dropdownMenuAssetButton"
            data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" ngbDropdownToggle [ngClass]="{'has-danger': selectedService && 
            selectedService.serviceName !== 'default' && filteredAssets.length > 0 && !case.assetId}">

            <!-- asset selected -->
            <ng-container *ngIf="case.assetId !== undefined">
              {{ selectedAssetDisplayName() }}
              <button *ngIf="filteredAssets.length > 1" type="button" class="btn btn-black btn-icon ms-2" (click)="updateAsset()">X</button>
            </ng-container>

            <!-- no service selected -->
              <ng-container *ngIf="(selectedService.serviceName === undefined || selectedService.serviceName ==='default') && !case.assetId">
                <div class="alert alert-info alert-sm" role="alert">
                  <span class="alert-icon"><span class="visually-hidden">Info</span></span>
                  <p>Select Asset ({{filteredAssets.length}})</p>
                </div>
              </ng-container>

            <!-- no asset selected -->
            <ng-container *ngIf="selectedService && selectedService.serviceName !== 'default' && filteredAssets.length > 0 && !case.assetId">
              <div class="alert alert-info alert-sm" role="alert">
                <span class="alert-icon"><span class="visually-hidden">Info</span></span>
                <p>{{'pages.support.log.noAssetSelected' | translate: { number: filteredAssets.length} }}</p>
              </div>
            </ng-container>

            <!-- no asset existing -->
            <ng-container *ngIf="selectedService && selectedService.serviceName !== 'default' && filteredAssets.length === 0 && !case.assetId">
              <div class="alert alert-info alert-sm" role="alert">
                <span class="alert-icon"><span class="visually-hidden">Info</span></span>
                <p>{{'pages.support.log.noExistingAsset' | translate }}</p>
              </div>
            </ng-container>
          </button>

          <!-- asset informations -->
          <div class="dropdown-menu dropdown-multicol" aria-labelledby="dropdownMenuAssetButton" ngbDropdownMenu>
            <div class="dropdown-item disabled">
              <span class="dropdown-detail dropdown-detail-sm">Vendor</span>
              <span class="dropdown-detail">Model</span>
              <span class="dropdown-detail">Name</span>
              <span class="dropdown-detail dropdown-detail-md">Serial Number</span>
            </div>
            <div class="dropdown-item" *ngFor="let asset of filteredAssets" (click)="updateAsset(asset);">
              <span class="dropdown-detail text-break dropdown-detail-sm">{{ asset.vendor }}</span>
              <span class="dropdown-detail text-break">{{ asset.model}}</span>
              <span class="dropdown-detail text-break">{{ asset.name}}</span>
              <span class="dropdown-detail text-break dropdown-detail-md">{{ asset.serialNumber }}</span>
            </div>
          </div>
        </div>
      </div>
    </span>
  </div>